import { useQuery } from "@tanstack/react-query";
import { catalogSubscriptionPlansService } from "@/services/catalog-subscription-plans-service";
import { ListSubscriptionPlansQuery } from "@/types/subscription-plan";

export const subscriptionPlanKeys = {
  all: ["subscriptionPlans"] as const,
  lists: () => [...subscriptionPlanKeys.all, "list"] as const,
  list: (query: ListSubscriptionPlansQuery) =>
    [...subscriptionPlanKeys.lists(), query] as const,
};

export const useSubscriptionPlans = (
  enabled: boolean,
  query: ListSubscriptionPlansQuery,
) => {
  return useQuery({
    queryKey: subscriptionPlanKeys.list(query),
    queryFn: () => catalogSubscriptionPlansService.getPlans(query),
    staleTime: 60 * 1000,
    enabled,
  });
};
